module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preregistration-details"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '-prereg')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('data-form', {
    attrs: {
      "entity": _vm.headData,
      "fields": _vm.headDataFields,
      "hide-buttons": ""
    },
    on: {
      "change": function (d) { return _vm.headData = d; }
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, _vm._l((2), function(i) {
    return _c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 24,
        "lg": 12
      }
    }, _vm._l((_vm.switches), function(swics, index) {
      return (swics.index % 2 == i - 1) ? _c('el-row', {
        key: index
      }, [_c('el-col', {
        attrs: {
          "xs": 24,
          "sm": 24,
          "md": 24,
          "lg": 24
        }
      }, [_c('h3', [_vm._v(_vm._s(swics.name))]), _vm._v(" "), _c('access-form', {
        attrs: {
          "access": _vm.getAccessForSwitch(swics),
          "buttons": [],
          "hideUserLevel": true,
          "disabled": !!_vm.getAccessForSwitch(swics).pending_access_id,
          "showRegStatus": ""
        },
        on: {
          "change": function (formModel) { return _vm.onChange(formModel, swics); }
        }
      })], 1)], 1) : _vm._e()
    }))
  })), _vm._v(" "), _c('div', {
    staticClass: "button-row"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save-scheduled')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.send')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.onCancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ade6e46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/preregistration/PreregistrationDetails.vue
// module id = 1144
// module chunks = 2